import { render } from "./AnalyticalTopproducts.vue?vue&type=template&id=0ef58785&scoped=true"
import script from "./AnalyticalTopproducts.vue?vue&type=script&lang=js"
export * from "./AnalyticalTopproducts.vue?vue&type=script&lang=js"

import "./AnalyticalTopproducts.vue?vue&type=style&index=0&id=0ef58785&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ef58785"]])

export default __exports__